import { reactive, set } from 'vue-demi';
export default (stockList, request) => {
    const chartDatas = reactive({});
    /* 股票图表数据 */
    const getChartData = async (stock) => {
        const params = {
            symbol: stock.symbol,
            stock_id: stock.stockId,
            market_code: stock.marketCode,
            type: 1,
            // 0代表 盘中数据
            req_section: 0
        };
        const r = await request.get('quote-minute', params);
        r.price_direct = stock.priceDirect;
        return r;
    };

    const initChartData = () => {
        if (!stockList.value || !stockList.value.length) {
            return;
        }
        stockList.value.map(async (stock) => {
            const chartData = (await getChartData(stock)) || [];
            set(chartDatas, stock.stockId, chartData);
        });
    };

    return {
        chartDatas,
        initChartData
    };
};
